import { render, staticRenderFns } from "./backToLogin.vue?vue&type=template&id=59650560&scoped=true&"
import script from "./backToLogin.vue?vue&type=script&lang=ts&"
export * from "./backToLogin.vue?vue&type=script&lang=ts&"
import style0 from "./backToLogin.vue?vue&type=style&index=0&id=59650560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59650560",
  null
  
)

export default component.exports